import React from "react";

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="section-pad"
        >
            <div className="container-edge">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <div className="h-px w-16 bg-foreground/30" />
                        <div className="mt-10 grid grid-cols-2 gap-px bg-border">
                            {[
                                { label: "Based", value: "London, UK" },
                                { label: "Working", value: "UK-wide" },
                                { label: "Tools", value: "SketchUp · Twinmotion" },
                                { label: "Focus", value: "Build-aware design" },
                            ].map((s) => (
                                <div key={s.label} className="bg-background p-5">
                                    <p className="overline">{s.label}</p>
                                    <p className="mt-2 text-[14px]">{s.value}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="md:col-span-8 md:pl-8">
                        <h2
                            data-testid="about-heading"
                            className="font-display text-4xl md:text-5xl lg:text-[56px] tracking-tight font-medium leading-[1.04] text-balance"
                        >
                            Design-led visuals,{" "}
                            <span className="italic font-normal text-champagne">
                                grounded in real event production.
                            </span>
                        </h2>
                        <div className="mt-10 space-y-5 text-foreground/75 text-[15px] leading-relaxed max-w-2xl">
                            <p>
                                I work across event visualisation, layout modelling
                                and production-aware spatial design.
                            </p>
                            <p>
                                My background in live events gives me a practical
                                understanding of how temporary spaces are actually
                                built, used and delivered on site. That includes
                                awareness of scale, access, guest flow, install
                                windows, materials, crew movement, venue restrictions,
                                supplier coordination and de-rig.
                            </p>
                            <p>
                                The result is visual work that helps creative ideas
                                become clearer, stronger and more achievable. The aim
                                is simple: to help clients understand the space
                                before it exists.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
